import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { ISubsidyBase } from '@/types'
import { Badge } from '@components-v2/atoms/Badge'
import styles from './index.module.scss'

type Props = {
  subsidy: ISubsidyBase
}

export const SubsidyItemContentLabel: FC<Props> = ({ subsidy }) => {
  const { t } = useTranslation('p')

  return (
    <div className={styles.container}>
      <Badge color='gray'>{t(subsidy.category)}</Badge>
    </div>
  )
}
